import '../../common/EsCommon.css';
import './EsHome.css';

import EsHomeHero from "./EsHomeHero";
import EsHomeFeatures from "./EsHomeFeatures";
import EsHomePrinciples from "./EsHomePrinciples";
import EsHomeRoadmap from "./EsHomeRoadmap";
import EsHomeFinances from "./EsHomeFinances";
import EsHomeContact from "./EsHomeContact";
import EsHomeScrollDown from "./EsHomeScrollDown";
import EsMinis from "../../common/EsMinis";

// `settled` comes from EsCrafterPage alone: false while Crafter's answer is pending and this
// tree is about to be replaced (see there). Mounted on its own it is unset, and the attribute
// is absent, so the switch off renders exactly what it rendered before.
export default function EsHome( { settled } ) {
  return (
      <div data-testid="es-home-page" data-settled={ settled } className="relative isolate">
          { /* Behind the sections, from below the hero's own wizard (18%), which is left out of the draw,
               and two pinned beside the roadmap's column. */ }
          <EsMinis exclude={ [ 'miniHumanFemaleWizard' ] } start={ 18 } beside="[data-es-minis-beside]" />
          <EsHomeHero />
          <EsHomeFeatures />
          <EsHomePrinciples />
          <EsHomeRoadmap />
          <EsHomeFinances />
          <EsHomeContact />
          <EsHomeScrollDown />
      </div>
  );
}